// extracted by mini-css-extract-plugin
module.exports = {"title":"title___1_cqp","featuredAuthor":"featuredAuthor___sqY7l"};